export default __webpack_public_path__ + "static/media/info-circle-grey.8f80ad02.svg";